const AppRouters = {
    home: "/",
    profile: "/perfil",
    newReport: "/nuevo-reporte",
    signIn: "/login",
    myReports: "/mis-reportes",
    myReportsError: "/mis-reportes/error/:error/*report",
    incompletePaymentError: "/mis-reportes/error/INCOMPLETE_PAYMENT",
    expiredPaymentError: "/mis-reportes/error/EXPIRED_PAYMENT",
    auth: "/usuario/login/:ticket",
    confirmWizardReport: "/validar-usuario/:ticket/reporte/:reportId",
    continueReportCheckout: "/confirmar-reporte",
    termAndConditions: "/term-and-conditions",
    reportDemo: "/idar/get_sample_pdf",
    questions: '/questions'
};

export default AppRouters;
